<div class="custom-scroll-parent">
  <div
    class="modal-body custom-scroll lightblue-scrollbar-track gpx-16 gpt-56 gpb-24"
  >
    <app-card-nav-item
      *ngIf="isLandscape"
      [title]="'DASHBOARD.TITLE'"
      icon="gpicon-dashboard"
      class="gmb-28 button"
      url="/dashboard"
    ></app-card-nav-item>

    <h4 class="h4-bold gmb-28">{{ 'RESULTS.MENU.ADD.TITLE' | translate }}</h4>

    <app-add-data-list></app-add-data-list>
  </div>
</div>
